import { Carousel, Col, Row } from 'react-bootstrap';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPayerTimeSpanDates } from 'store/customer/customer-view-actions';
import McoCustomerInfo from './McoCustomerInfo';
import classes from './McoBanner.module.scss';
import McoPieChart from './McoPieChart';
import { setPayerTimeFrameDates } from 'store/customer/customerViewSlice';
import { useQuery } from '@tanstack/react-query';
import { QUERY_KEY } from 'constants/constants';

const Banner = (props) => {
  const dispatch = useDispatch();
  const { roleId } = useSelector((state) => state?.Auth?.userClaimObject);

  // React Query to fetch Payer TimeSpan Data
  const { data: payerTimeSpan } = useQuery({
    queryKey: [QUERY_KEY.MCOTimePeriod, roleId],
    queryFn: async () => {
      const response = await getPayerTimeSpanDates({ roleId });
      return response;
    },
  });

  // Set Payer TimeFrame Dates in Redux Store
  useEffect(() => {
    if (payerTimeSpan) {
      dispatch(setPayerTimeFrameDates(payerTimeSpan));
    }
  }, [payerTimeSpan]);

  return (
    <Carousel>
      <Carousel.Item>
        <section
          className={`${classes['banner-wrapper']} animate__animated animate__fadeIn animate__slower`}>
          <Row>
            <Col
              md={9}
              xxl={9}
              className='ps-0'>
              <McoCustomerInfo />
            </Col>
            <Col
              md={3}
              xxl={3}
              className='pe-0'>
              <McoPieChart />
            </Col>
          </Row>
        </section>
      </Carousel.Item>
    </Carousel>
  );
};

export default Banner;
